import { isNailAvulsion } from "./conditions";
import { GrossingSegment } from "./segments";
import {
  falseMarginsSegments,
  incidentalForeignBodySegments,
  smallTissueSegments,
  softenedAndDecalcifiedSegments,
} from "./segmentsCommon";

// An alternate set of GrossingSegments for use with the Nail Protocol.

export const grossingSegments: GrossingSegment[] = [
  {
    content:
      'The specimen received labeled with patient name and "{source}" consists of {clipping_count}',
  },
  {
    content:
      " portion[clippingsS] of nail measuring {measurement_w} cm x {measurement_l} cm x {measurement_h} cm,",
    condition: isNailAvulsion,
  },
  {
    content:
      " nail clipping[clippingsS] measuring {measurement_w} cm x {measurement_l} cm,",
    condition: (s) => !isNailAvulsion(s),
  },
  {
    content: " entirely submitted for histology as {cassette_count}.",
  },
  ...smallTissueSegments,
  ...falseMarginsSegments,
  ...softenedAndDecalcifiedSegments,
  ...incidentalForeignBodySegments,
  {
    content: " Special stains: PAS-F.",
    condition: ({ modifierSelections }) => modifierSelections.pasf,
  },
];

export default grossingSegments;
